import { FC, ReactNode } from 'react';

import './Grid.css';
interface GridProps {
    className?: string;
    children: ReactNode;
    columns: number;
    rows?: number;
    gap?: 'no' | 'xs' | 'sm' | 'md' | 'lg';
}

export const Grid: FC<GridProps> = ({ children, columns, rows = 'auto', gap = 'md', className = '' }) => {

    const gapVariable = `var(--layout--spacing--${gap})`;

    const gridStyle = {
        '--grid-columns': columns,
        '--grid-rows': rows,
        '--grid-gap': gapVariable,
    } as React.CSSProperties;
    
    return (
        <div className={`grid ${className}`} style={gridStyle}>
            {children}
        </div>
    );
};